/* eslint-disable @typescript-eslint/camelcase */
const messages = {
  dev_app: {
    error: 'Unable to process the request.',
    title: 'Help',
    video:'Your browser does not support HTML video.'
  },
};

export default { messages };